import { render } from "./CreateBankDetailsPage.vue?vue&type=template&id=af7aca02"
import script from "./CreateBankDetailsPage.vue?vue&type=script&lang=js"
export * from "./CreateBankDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__